import cn from 'classnames/bind';
import React__default from 'react';
import 'classnames';
import '../../UIElements/Button/index.js';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import { Tooltip } from '../../UIElements/Tooltip/Tooltip/index.js';
import { TooltipIcon } from './TooltipIcon.js';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const InputHeader = ({ name, label, rightLabel, secondaryLabel, tooltip, style = 'default', }) => {
    if (!label && !rightLabel && !secondaryLabel && !tooltip) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return (React__default.createElement("div", { className: cx('cactus-input-header__wrapper') },
        React__default.createElement("div", { className: cx('input-header', `style-${style}`) },
            React__default.createElement("div", null,
                label && (React__default.createElement("label", { htmlFor: name, className: cx('label') }, label)),
                secondaryLabel && (React__default.createElement("span", { className: cx('secondary-label', 'size-small', 'weight-book') }, secondaryLabel)),
                tooltip && (React__default.createElement(Tooltip, { ...tooltip, arrowPosition: tooltip.arrowPosition ?? 'left-center', classes: [...(tooltip.classes ?? []), cx('tooltip')] }, TooltipIcon))),
            rightLabel && (React__default.createElement("span", { className: cx('right-label', 'weight-book') }, rightLabel)))));
};

export { InputHeader };
//# sourceMappingURL=index.js.map
